let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cB2cH")).then(() => parcelRequire('5fTJi'));